import { useContext } from 'react';

import { ContextWrapper } from 'contexts/wrapper.context';
import { getPagesAccess } from 'utils/permissions/permissions-apply';

import NewPageBtn from 'components/Pages/components/NewPageBtn/NewPageBtn';
import PagesTable from 'components/Pages/components/PagesList/components/PagesTable/PagesTable';

import './PageList.less';

const PageList = ({ pages = [], setIsLoading, setPages }) => {
  const { businessInfo } = useContext(ContextWrapper);

  const { HIDE_CREATE_PAGE } = getPagesAccess(
    businessInfo?.userSllrPermissions
  );

  return (
    <div className="br-pages-list">
      <div className="br-pages-list__subheader">
        {!HIDE_CREATE_PAGE && <NewPageBtn />}
      </div>
      <PagesTable
        pages={pages}
        setIsLoading={setIsLoading}
        setPages={setPages}
        permissions={getPagesAccess(businessInfo?.userSllrPermissions)}
      />
    </div>
  );
};

export default PageList;
